import "../css/master.css";

function UserInfoCom() {
    let userName;
    const userNameStorage = localStorage.getItem("userName");
    let style = {
        padding: '10px 30px 10px 16px'
    }
    if (userNameStorage !== null) {
        userName = userNameStorage + " 様";
    }

    return (
        <div className="root js-btn-nav-local">
            <div style={style}>
                <span id="topUserName">{userName}</span>
            </div>
        </div>
    );
}

export default UserInfoCom;